<script setup lang="ts">
import useCmd from "@/composables/useCmd";
import { ButtonNormal, ModalCreate, types } from "lorga-ui";
import { toRefs } from "vue";

const props = defineProps<{
  query: () => void;
  kundenFirma: string;
  kundenAnsprechpartner: string;
  kundenId: string;
  kundenAnzeigeName: string | undefined;
}>();
const { query } = toRefs(props);

const fields: types.FormField[] = [
  {
    label: "Firma",
    name: "firma",
    type: "text",
    required: true,
  },
  {
    label: "Anzeigename",
    name: "anzeigename",
    type: "text",
    required: true,
  },
  {
    label: "Ansprechpartner",
    name: "ansprechpartner",
    type: "text",
    required: true,
  },
];

const { commandModalOpen, commandRequest } = useCmd(query);
</script>

<template>
  <ButtonNormal kind="action" @click="commandModalOpen = true">
    <ModalCreate
      v-model="commandModalOpen"
      submit="Speichern"
      title="Fahrer Bearbeiten"
      :data="{
        action: 'kunden.bearbeiten',
        firma: kundenFirma,
        anzeigename: kundenAnzeigeName,
        ansprechpartner: kundenAnsprechpartner,
        kunden_id: kundenId,
      }"
      :fields="fields"
      :request="commandRequest"
    />
    Bearbeiten
  </ButtonNormal>
</template>
